export const Spinner = ({className}) => {
    return (
        <div
            className={`${className} inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-nt-blue border-e-transparent text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] `}
            role="status">
            <span
                className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]"
                >Loading...</span >
            </div>
    )
}